import { useMutation } from "@tanstack/react-query";

import { attendanceAttachmentUrl } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";

const REVOKE_DELAY = 60_000;

export interface OpenAttachmentInput {
	workerId: string;
	date: string;
	attachmentId: string;
}

export function useOpenAttachment() {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: async (input: OpenAttachmentInput) => {
			const url = await attendanceAttachmentUrl(
				activeCanteiroId as string,
				input.workerId,
				input.date,
				input.attachmentId,
			);
			try {
				const anchor = document.createElement("a");
				anchor.href = url;
				anchor.target = "_blank";
				anchor.rel = "noopener";
				document.body.appendChild(anchor);
				anchor.click();
				anchor.remove();
			} finally {
				setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY);
			}
		},
	});
}
